import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { DevAuth0Provider } from './components/auth/DevAuth0Provider';
import { AuthUserProvider } from './contexts/AuthUserContext';
import { CustomerProvider } from './contexts/CustomerContext';
import { NavbarProvider } from './contexts/NavbarContext';
import { CallDataProvider } from './contexts/CallDataContext';
import { SentimentProvider } from './contexts/SentimentContext';
import { WeekProvider } from './contexts/WeekContext';
import { TicketProvider } from './contexts/TicketContext';
import { AlertsProvider } from './contexts/AlertsContext';
import { ClientsProvider } from './contexts/ClientsDataContext';
import { KronkOrdersProvider } from './contexts/KronkOrdersContext';
import { ThemeProvider } from './contexts/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <DevAuth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email'
    }}
    onRedirectCallback={(appState) => {
      window.history.replaceState({}, document.title, appState?.returnTo || '/app')
    }}
  >
    <ThemeProvider>
      <AuthUserProvider>
        <CustomerProvider>
          <NavbarProvider>
            <CallDataProvider>
              <AlertsProvider>
                <ClientsProvider>
                  <WeekProvider>
                    <SentimentProvider>
                      <TicketProvider>
                        <KronkOrdersProvider>
                          <App />
                        </KronkOrdersProvider>
                      </TicketProvider>
                    </SentimentProvider>
                  </WeekProvider>
                </ClientsProvider>
              </AlertsProvider>
            </CallDataProvider>
          </NavbarProvider>
        </CustomerProvider>
      </AuthUserProvider>
    </ThemeProvider>
  </DevAuth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
